import { useFeatureFlag } from '@/scopes/common/infrastructure/feature-flags'
import { Filters } from '@/scopes/prices/components/Filters'
import { Filters as FiltersLegacy } from '@/scopes/prices/components/FiltersLegacy'
import { GoBack } from '@/scopes/prices/components/GoBack'
import { GridTabsProvider } from '@/scopes/prices/components/GridTabsContext'
import { PriceConfiguratorByWeeks } from '@/scopes/prices/components/PriceTableByWeeks/PriceConfiguratorByWeeks'
import {
  getFiltersSelector,
  isPriceTableLoadingStateSelector,
} from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { LoadingSpinner, tokPx } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { css, styled } from 'styled-components'

const Wrapper = styled.div<{ $disabled: boolean }>`
  display: flex;
  position: relative;
  justify-content: center;

  max-width: 1312px;

  flex-direction: column;

  & > * {
    margin-bottom: ${tokPx('primitives_space_16')};;
  }

  ${({ $disabled }) =>
    $disabled
    && css`
      opacity: 0.25;
      pointer-events: none;
    `}
`

const Loader = styled(LoadingSpinner)`
  margin: auto;
`

interface PriceTableProps {
  onClickBack?: () => void
}

export function PriceTableByWeeks({ onClickBack }: PriceTableProps) {
  const { loading: filtersLoading } = usePricesSelector(getFiltersSelector)
  const isLoading = usePricesSelector(isPriceTableLoadingStateSelector)
  const ENABLE_UDS_PRICES_FILTERS = useFeatureFlag('ENABLE_UDS_PRICES_FILTERS')

  if (filtersLoading) {
    return <Loader />
  }

  return (
    <GridTabsProvider>
      <Wrapper $disabled={isLoading} data-qa-pt-ready={!isLoading}>
        <GoBack onClick={onClickBack} />
        { ENABLE_UDS_PRICES_FILTERS ? <Filters /> : <FiltersLegacy /> }
        <PriceConfiguratorByWeeks />
      </Wrapper>
    </GridTabsProvider>
  )
}
